import { createContext } from 'react'

/**
 * When `true`, child components should render the unified MakeHeader
 * with `showTimeline` enabled (make/timeline flow) instead of the
 * default header (jump-menu flow).
 */
const MakeContext = createContext(false)

export default MakeContext
